import axios from 'axios';

import { FETCH_POSTS } from '../constants/post';
import { REACT_APP_WORD_PRESS_API } from '../env';

export const fetchPosts = (posts) => {
  return {
    type: FETCH_POSTS,
    payload: posts,
  }
}

export const requestPosts = () => {
  // Returns the promise so callers can await the request and drop their loading state.
  return (dispatch) => {
    return axios.get(REACT_APP_WORD_PRESS_API)
      .then(({ data }) => dispatch(fetchPosts(data.posts || [])))
      .catch(err => {
        console.error('Failed to load posts', err);
        return null;
      });
  }
}
